import React from 'react';
import { translate } from '@utils/i18n';
import { KIT_ORDERS_NAMESPACE, KIT_ORDER_STATUS } from '../constants';
export default function KitOrderStatusCell({ tdProps, dataItem }) {
    const labelKey = dataItem.status === KIT_ORDER_STATUS.PENDING ? 'sent' : 'received';
    const label = translate(`kit_orders.status.${labelKey}`, {
        namespace: KIT_ORDERS_NAMESPACE,
        defaultValue: labelKey === 'sent' ? 'Sent' : 'Received'
    });
    return (React.createElement("td", Object.assign({}, tdProps),
        React.createElement("span", { className: `kit-order-status kit-order-status--${dataItem.status}` }, label)));
}
